import { useEffect, useState } from 'react';
import { useUnmount } from '~/utils/use-unmount';

export function HelpEmbed({
  openStyle = 'float',
  user,
  widgetUrl
}: {
  openStyle?: 'float' | 'modal';
  user?: {
    email?: string | null;
    id?: string | null;
    name?: string | null;
  };
  widgetUrl: string;
}) {
  const [loading, setLoading] = useState(false);

  useUnmount(() => {
    typeof window !== 'undefined' && window.AtlasSettings && window.closeAtlasEmbed?.();
  });

  useEffect(() => {
    // Check if the script is already loaded
    if (!loading) {
      setLoading(true);
      const loaderScript = document.getElementById('atlas-loader');
      if (!loaderScript) {
        // If not loaded, create and load the script
        const script = document.createElement('script');
        script.setAttribute('async', '');
        script.setAttribute('id', 'atlas-loader');
        script.src = widgetUrl;
        script.addEventListener('load', () => {
          window.AtlasSettings = {
            openStyle,
            openSide: 'right',
            embedId: 'tia',
            userEmail: user?.email,
            userId: user?.id,
            userName: user?.name
          };
        });

        document.body.appendChild(script);
      }
    }
  }, [loading, widgetUrl, user?.email, user?.id, user?.name, openStyle]);

  return null;
}
